import { createFileRoute } from '@tanstack/react-router'
import FlashcardGenerator from '@/components/studentPage/FlashcardGenerator'
import { guardStudentOrB2CClient } from '@/lib/auth/routeGuards'

export const Route = createFileRoute('/student/flashcards')({
  beforeLoad: guardStudentOrB2CClient,
  component: FlashcardsPage,
})

function FlashcardsPage() {
  console.log('Rendering FlashcardsPage component')
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <FlashcardGenerator />
    </div>
  )
}
